import { render, staticRenderFns } from "./c_upload_img.vue?vue&type=template&id=1cd82bba&scoped=true"
import script from "./c_upload_img.vue?vue&type=script&lang=js"
export * from "./c_upload_img.vue?vue&type=script&lang=js"
import style0 from "./c_upload_img.vue?vue&type=style&index=0&id=1cd82bba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd82bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd82bba')) {
      api.createRecord('1cd82bba', component.options)
    } else {
      api.reload('1cd82bba', component.options)
    }
    module.hot.accept("./c_upload_img.vue?vue&type=template&id=1cd82bba&scoped=true", function () {
      api.rerender('1cd82bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_upload_img.vue"
export default component.exports